import { render } from "./CancelOrderModal.vue?vue&type=template&id=d1287ff0"
import script from "./CancelOrderModal.vue?vue&type=script&lang=js"
export * from "./CancelOrderModal.vue?vue&type=script&lang=js"

import exportComponent from "/tmp/build_719f45e5/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__